// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 1400;
}
.UpdateModal .UpdateModalContainer {
  width: calc(100% - 12.5rem);
  height: calc(100% - 5rem);
  margin: 2.5rem 6.25rem;
  background: var(--Background);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 1.25rem;
}
.UpdateModal .UpdateModalContainer .SearchPacklist {
  flex: 1 1;
  border: 0.0625rem solid var(--Stroke);
  width: 100%;
  padding: 1rem;
  border-radius: 0.375rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  overflow: auto;
}
.UpdateModal .UpdateModalContainer .SearchPacklist input {
  width: calc(100% - 2.5rem);
  padding: 0 2.5rem 0 1rem;
  height: 2rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
  font-size: 0.875rem;
  background: var(--Foreground);
  color: var(--TextColor);
}
.UpdateModal .UpdateModalContainer .SearchPacklist .SearchIcon {
  position: absolute;
  top: 1.375rem;
  right: 1.5rem;
  cursor: pointer;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .SearchIcon path {
  fill: var(--AccentColor);
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper {
  flex: 1 1;
  overflow: auto;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer {
  flex: 1 1;
  width: calc(100% - 1.25rem);
  padding: 0 0.625rem 1.25rem 0.625rem;
  columns: 4;
  column-gap: 1.25rem;
  overflow: auto;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack {
  background: var(--Foreground);
  width: 100%;
  padding: 1.25rem 0.625rem;
  border-radius: 0.625rem;
  border: 0.0625rem solid var(--Background);
  margin-bottom: 0.625rem;
  page-break-inside: avoid;
  break-inside: avoid;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0.0625rem 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.0196078431);
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack h3 {
  min-width: 9.375rem;
  max-width: 12.5rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--AccentColor);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .Amount {
  font-size: 2rem;
  font-weight: 700;
  white-space: nowrap;
  color: var(--TextColor);
  margin: 0.625rem 0;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .InclTax {
  font-size: 0.625rem;
  padding-bottom: 1.25rem;
  width: calc(100% - 2.5rem);
  border-bottom: 0.0625rem solid #515151;
  text-align: center;
  color: var(--TextColor);
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .Checks {
  width: 100%;
  padding: 0 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .Checks svg {
  min-width: 0.75rem;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .Checks span {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack .Checks input {
  min-width: 0.75rem;
  min-height: 0.75rem;
  width: 0.75rem;
  height: 0.75rem;
  accent-color: var(--AccentColor);
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Pack:hover {
  background: var(--Hover);
  cursor: pointer;
}
.UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer .Active {
  background: var(--Hover);
  border: 0.0625rem solid var(--AccentColor);
}
.UpdateModal .UpdateModalContainer .ButtonContainer {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 2.5rem;
  justify-content: center;
}
.UpdateModal .UpdateModalContainer .ButtonContainer .Cancel {
  background: #cbcbcb;
  color: #000000;
}
.UpdateModal .UpdateModalContainer .ButtonContainer button {
  background: var(--AccentColor);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  width: 7.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 0.375rem;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

.UpdateLoaderContainer {
  position: relative;
  width: 100%;
  height: 100%;
}

@media (max-width: 1200px) {
  .UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer {
    columns: 3;
  }
}
@media (max-width: 800px) {
  .UpdateModal .UpdateModalContainer {
    width: calc(100% - 6.5rem);
    height: calc(100% - 3rem);
    margin: 1.5rem 3.25rem;
  }
  .UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer {
    columns: 2;
  }
}
@media (max-width: 600px) {
  .UpdateModal .UpdateModalContainer .SearchPacklist .PackContWrapper .PackContainer {
    columns: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/CandidateDetails/Actions/UpdateModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;EACA,uCAAA;EACA,0BAAA;EACA,aAAA;AACF;AAAE;EACE,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;AADI;EACE,SAAA;EACA,qCAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAGN;AAFM;EACE,0BAAA;EACA,wBAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;AAIR;AAFM;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AAIR;AAHQ;EACE,wBAAA;AAKV;AAFM;EACE,SAAA;EACA,cAAA;AAIR;AAHQ;EACE,SAAA;EACA,2BAAA;EACA,oCAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;AAKV;AAJU;EACI,6BAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,yCAAA;EACA,uBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sEAAA;AAMd;AALc;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAOhB;AALc;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAOhB;AALc;EACE,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;AAOhB;AALc;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAOhB;AANgB;EACE,kBAAA;AAQlB;AANgB;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAQlB;AANgB;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;AAQlB;AAJY;EACE,wBAAA;EACA,eAAA;AAMd;AAJY;EACE,wBAAA;EACA,0CAAA;AAMd;AADI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AAGN;AAFM;EACE,mBAAA;EACA,cAAA;AAIR;AAFM;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAIR;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAGA;EAKU;IACE,UAAA;EAJV;AACF;AAWA;EAEI;IACE,0BAAA;IACA,yBAAA;IACA,sBAAA;EAVJ;EAaQ;IACE,UAAA;EAXV;AACF;AAkBA;EAKU;IACE,UAAA;EApBV;AACF","sourcesContent":[".UpdateModal{\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  background: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 1400;\n  .UpdateModalContainer{\n    width: calc(100% - 12.5rem);\n    height: calc(100% - 5rem);\n    margin: 2.5rem 6.25rem;\n    background: var(--Background);\n    border-radius: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.25rem;\n    padding: 1.25rem;\n    .SearchPacklist{\n      flex: 1;\n      border: 0.0625rem solid var(--Stroke);\n      width: 100%;\n      padding: 1rem;\n      border-radius: 0.375rem;\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      position: relative;\n      overflow: auto;\n      input{\n        width: calc(100% - 2.5rem);\n        padding: 0 2.5rem 0 1rem;\n        height: 2rem;\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        background: var(--Foreground);\n        color: var(--TextColor);\n      }\n      .SearchIcon{\n        position: absolute;\n        top: 1.375rem;\n        right: 1.5rem;\n        cursor: pointer;\n        path{\n          fill: var(--AccentColor);\n        }\n      }\n      .PackContWrapper{\n        flex: 1;\n        overflow: auto;\n        .PackContainer{\n          flex: 1;\n          width: calc(100% - 1.25rem);\n          padding: 0 0.625rem 1.25rem 0.625rem;\n          columns: 4;\n          column-gap: 1.25rem;\n          overflow: auto;\n          .Pack{\n              background: var(--Foreground);\n              width: 100%;\n              padding: 1.25rem 0.625rem;\n              border-radius: 0.625rem;\n              border: 0.0625rem solid var(--Background);\n              margin-bottom: 0.625rem;\n              break-inside: avoid;\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              box-shadow: 0.0625rem 0.0625rem 0.625rem 0 #00000005;\n              h3{\n                min-width: 9.375rem;\n                max-width: 12.5rem;\n                text-align: center;\n                font-size: 1.125rem;\n                font-weight: 700;\n                color: var(--AccentColor);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              }\n              .Amount{\n                font-size: 2rem;\n                font-weight: 700;\n                white-space: nowrap;\n                color: var(--TextColor);\n                margin: 0.625rem 0;\n              }\n              .InclTax{\n                font-size: 0.625rem;\n                padding-bottom: 1.25rem;\n                width: calc(100% - 2.5rem);\n                border-bottom: 0.0625rem solid #515151;\n                text-align: center;\n                color: var(--TextColor);\n              }\n              .Checks{\n                width: 100%;\n                padding: 0 1.25rem;\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 0.75rem;\n                margin-top: 0.75rem;\n                svg{\n                  min-width: 0.75rem;\n                }\n                span{\n                  font-size: 0.75rem;\n                  font-weight: 400;\n                  color: var(--TextColor);\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                  cursor: pointer;\n                }\n                input{\n                  min-width: 0.75rem;\n                  min-height: 0.75rem;\n                  width: 0.75rem;\n                  height: 0.75rem;\n                  accent-color: var(--AccentColor);\n                }\n              }\n            }\n            .Pack:hover{\n              background: var(--Hover);\n              cursor: pointer;\n            }\n            .Active{\n              background: var(--Hover);\n              border: 0.0625rem solid var(--AccentColor);\n            }\n        }\n      }\n    }\n    .ButtonContainer{\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      gap: 2.5rem;\n      justify-content: center;\n      .Cancel{\n        background: #cbcbcb;\n        color: #000000;\n      }\n      button{\n        background: var(--AccentColor);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        font-size: 0.875rem;\n        width: 7.5rem;\n        height: 2.5rem;\n        border: none;\n        border-radius: 0.375rem;\n        color: #ffffff;\n        text-align: center;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.UpdateLoaderContainer{\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n\n@media (max-width: 1200px) {\n  .UpdateModal{\n    .UpdateModalContainer{\n      .SearchPacklist{\n        .PackContWrapper{\n          .PackContainer{\n            columns: 3;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 800px) {\n  .UpdateModal{\n    .UpdateModalContainer{\n      width: calc(100% - 6.5rem);\n      height: calc(100% - 3rem);\n      margin: 1.5rem 3.25rem;\n      .SearchPacklist{\n        .PackContWrapper{\n          .PackContainer{\n            columns: 2;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .UpdateModal{\n    .UpdateModalContainer{\n      .SearchPacklist{\n        .PackContWrapper{\n          .PackContainer{\n            columns: 1;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
